import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { useImageLoading, SkeletonLoading, useIdentificationContext } from '@fiverr-private/identification_core';
import { List, ListItem, ListItemIcon } from '@fiverr-private/list';
import { CheckIcon } from '@fiverr-private/visuals';
import { appTranslate, CopyKey } from '../../../i18n';
import wnwBackgroundImage from '../../../assets/wnw_main.png';
import { responsiveImg } from '../../../shared/styles/index.ve.css';
import { WNW_BANNER_SIGN_UP_COPY_KEYS, WNW_BANNER_SIGN_IN_COPY_KEYS } from './WnWBanner.constants';

const imageSrc = wnwBackgroundImage;

export const WnWBanner = () => {
    const { mode } = useIdentificationContext();
    const { loading, onLoad } = useImageLoading(imageSrc);

    const isSignUp = mode === 'sign_up';
    const title = (isSignUp ? 'wnw_flow.banner.sign_up.title' : 'wnw_flow.banner.sign_in.title') satisfies CopyKey;
    const benefitsList = isSignUp ? WNW_BANNER_SIGN_UP_COPY_KEYS : WNW_BANNER_SIGN_IN_COPY_KEYS;

    return (
        <SkeletonLoading loading={loading}>
            <Container position="relative" height="100%" width="100%">
                <Container width="100%" paddingY="14" paddingX="10" position="absolute">
                    <Heading color="white" as="h4">
                        {appTranslate(title)}
                    </Heading>

                    <List paddingLeft="0" marginTop="6">
                        {benefitsList.map((key, index) => (
                            <ListItem key={index} marginBottom="2">
                                <ListItemIcon>
                                    <CheckIcon size="xs" color="white" />
                                </ListItemIcon>
                                <Text size="b_md" color="white">
                                    {appTranslate(key)}
                                </Text>
                            </ListItem>
                        ))}
                    </List>
                </Container>

                <img
                    onLoad={onLoad}
                    alt={appTranslate<string>('identification.banner.image_alt')}
                    className={responsiveImg}
                    src={imageSrc}
                />
            </Container>
        </SkeletonLoading>
    );
};
